import styles from './SegmentedToggle.module.css';

export interface SegmentedToggleOption<T extends string> {
	value: T;
	label: string;
}

export interface SegmentedToggleProps<T extends string> {
	options: SegmentedToggleOption<T>[];
	value: T;
	onChange: (value: T) => void;
	ariaLabel: string;
}

export const SegmentedToggle = <T extends string>({
	options,
	value,
	onChange,
	ariaLabel,
}: SegmentedToggleProps<T>) => (
	<div className={styles.group} role="tablist" aria-label={ariaLabel}>
		{options.map((option) => (
			<button
				key={option.value}
				type="button"
				role="tab"
				aria-selected={value === option.value}
				className={`${styles.option} ${value === option.value ? styles.optionActive : ''}`}
				onClick={() => onChange(option.value)}
			>
				{option.label}
			</button>
		))}
	</div>
);
